import React, {useEffect, useRef, useState} from "react";
import "./CustomRequest.css";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faPaperPlane, faCircleNotch, faCaretLeft, faCaretRight
} from '@fortawesome/free-solid-svg-icons'
import {faTrashCan} from "@fortawesome/free-regular-svg-icons";

import {Accordion} from "react-bootstrap";
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';

import FloatingLabel from 'react-bootstrap/FloatingLabel';
import ReactJsonView from '@microlink/react-json-view'


function CustomRequest({bondApi}) {
    const [isWaitingResponse, setIsWaitingResponse] = useState(false);
    const [requestMethod, setRequestMethod] = useState("GET");
    const requestPath = useRef("New Request");
    const requestBody = useRef(null);
    const [responseClass, setResponseClass] = useState("");
    const [requestResponseStatus, setRequestResponseStatus] = useState("");
    const [requestResponseContent, setRequestResponseContent] = useState({});

    const [requestHistory, setRequestHistory] = useState([]);
    const [requestHistoryIndex, setRequestHistoryIndex] = useState(0);

    class Request {
        constructor(method, path, body, response) {
            this.method = method;
            this.path = path;
            this.body = body;

            this.response = response;

            this.response_status = null;
            this.response_body = null;
            this.response_content = null;
        }

        async build() {
            if (!this.response || this.response_status) return;
            if (this.response.status < 300) {
                const responseObject = await this.response.json();
                this.response_status = this.response.status;
                this.response_body = responseObject;
                this.response_content = this.response_body;
            } else {
                this.response_status = this.response.status;
                this.response_body = null;
                let _response_content = await this.response.text();
                try {
                    _response_content = JSON.parse(_response_content);
                } catch {
                    _response_content = null;
                }
                this.response_content = _response_content === "null" ? null : _response_content;
            }
        }
    }

    useEffect(() => {
        if (requestHistory && requestHistory.length > 0) {
            saveRequestHistory(requestHistory);
        } else {
            const history = loadRequestHistory();
            if (history && history.length > 0) {
                setRequestHistory(history);
                populateRequest(history[0]);
            }
        }
    }, [requestHistory]);


    useEffect(() => {
        if (!requestHistory || requestHistory.length === 0) return;

        if (requestHistoryIndex < 0) {
            setRequestHistoryIndex(0);
            return
        }
        if (requestHistoryIndex >= requestHistory.length) {
            setRequestHistoryIndex(requestHistory.length - 1);
            return
        }
        handleRequestIndexChange();
    }, [requestHistoryIndex]);

    function getRequestHistoryId() {
        return `requestHistory-${bondApi.id}`;
    }

    function saveRequestHistory(reqHistory) {
        localStorage.setItem(getRequestHistoryId(), JSON.stringify(reqHistory));
    }

    function loadRequestHistory() {
        const savedHistory = localStorage.getItem(getRequestHistoryId());
        return savedHistory ? JSON.parse(savedHistory) : [];
    }

    function handleRequestIndexChange() {
        const request = requestHistory[requestHistoryIndex];
        populateRequest(request);
    }

    function deleteRequest(index) {
        const updatedHistory = requestHistory.filter((_, i) => i !== index);
        setRequestHistory(updatedHistory);
        if (requestHistoryIndex === index) {
            if (updatedHistory.length > 0) populateRequest(updatedHistory[0]); else populateRequest(null);
        }
    }

    function populateRequest(request) {
        if (!request) {
            setRequestMethod("GET");
            setRequestResponseStatus("");
            setRequestResponseContent({});
            requestPath.current.value = "";
        } else {
            setResponseClass(request.response_status >= 200 && request.response_status < 300 ? "success" : "error");
            setRequestResponseStatus("< " + request.response_status);
            setRequestResponseContent(request.response_content);
            setRequestMethod(request.method);
            if (request.body && requestBody.current) requestBody.current.value = request.body;
            requestPath.current.value = request.path;
        }
    }

    function sendRequest() {
        if (isWaitingResponse) return;
        setIsWaitingResponse(true);
        if (!requestPath.current.value.startsWith("/")) requestPath.current.value = "/" + requestPath.current.value;

        let _requestBody = null;
        if (["POST", "PATCH", "PUT"].indexOf(requestMethod) >= 0) if (requestBody.current.value.length > 0) _requestBody = requestBody.current.value;

        setResponseClass("");
        setRequestResponseStatus(" ... ");
        setRequestResponseContent({});

        bondApi._request(requestPath.current.value, requestMethod, _requestBody).then((response) => {
            setIsWaitingResponse(false);
            const request = new Request(requestMethod, requestPath.current.value, _requestBody, response);
            request.build().then(() => {
                const lastRequest = requestHistory[requestHistoryIndex];
                if (!lastRequest || lastRequest.method !== request.method || lastRequest.path !== request.path || lastRequest.body !== request.body) {
                    setRequestHistory([...requestHistory.slice(0, requestHistoryIndex + 1), request, ...requestHistory.slice(requestHistoryIndex + 1)]);
                    setRequestHistoryIndex(requestHistoryIndex + 1);
                } else {
                    requestHistory[requestHistoryIndex] = request;
                    setRequestHistory(requestHistory);
                }
                setResponseClass(request.response_status >= 200 && request.response_status < 300 ? "success" : "error");
                setRequestResponseStatus("< " + request.response_status);
                setRequestResponseContent(request.response_content);
            });
        }).catch((error) => {
            setIsWaitingResponse(false);
            setResponseClass("error");
            setRequestResponseStatus("Error");
            setRequestResponseContent(error);
        });
    }

    return <Accordion.Body className="customRequestBody">
        <InputGroup className="">
            <DropdownButton
                variant="outline-primary"
                title={requestMethod}
                id="input-group-dropdown-1"
            >
                <Dropdown.Item href="#" onClick={() => {
                    setRequestMethod("GET")
                }}>GET</Dropdown.Item>
                <Dropdown.Item href="#" onClick={() => {
                    setRequestMethod("POST")
                }}>POST</Dropdown.Item>
                <Dropdown.Item href="#" onClick={() => {
                    setRequestMethod("PUT")
                }}>PUT</Dropdown.Item>
                <Dropdown.Item href="#" onClick={() => {
                    setRequestMethod("PATCH")
                }}>PATCH</Dropdown.Item>
                <Dropdown.Item href="#" onClick={() => {
                    setRequestMethod("DELETE")
                }}>DELETE</Dropdown.Item>
            </DropdownButton>
            <Form.Control ref={requestPath}
                          placeholder={"/"}
                          onKeyDown={(e) => {
                              if (e.key === 'Enter') sendRequest(); else if (e.key === 'ArrowLeft' && (e.metaKey || e.ctrlKey)) {
                                  setRequestHistoryIndex(requestHistoryIndex - 1)
                              } else if (e.key === 'ArrowRight' && (e.metaKey || e.ctrlKey)) {
                                  setRequestHistoryIndex(requestHistoryIndex + 1)
                              }
                          }}/>

            {requestHistory.length > 1 ? <>
                <Button variant="outline-secondary" onClick={() => {
                    setRequestHistoryIndex(requestHistoryIndex - 1)
                }}>
                    <FontAwesomeIcon icon={faCaretLeft}/>
                </Button>

                <Dropdown drop={"down"}>
                    <Dropdown.Toggle variant="outline-secondary" className={"customRequestDropToggle"}>
                        {requestHistoryIndex + 1}/{requestHistory.length}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="dropdownRequestMenu">
                        {requestHistory.map((req, index) => (
                            <div key={"reqHistory" + index} className={"customRequestDropItem"}>
                                <Dropdown.Item key={index} onClick={() => setRequestHistoryIndex(index)}>
                                    <InputGroup className="">
                                        <InputGroup.Text>{`[${req.method}] ${req.path}`}</InputGroup.Text>

                                        <Button variant="outline-danger" onClick={() => {
                                            deleteRequest(index);
                                            setRequestHistoryIndex(requestHistoryIndex + 1)
                                        }}>
                                            <FontAwesomeIcon icon={faTrashCan} size={"sm"}/>
                                        </Button>
                                    </InputGroup>
                                </Dropdown.Item>
                                {index < requestHistory.length - 1 && <Dropdown.Divider/>}
                            </div>))}
                    </Dropdown.Menu>
                </Dropdown>

                <Button variant="outline-secondary" onClick={() => {
                    setRequestHistoryIndex(requestHistoryIndex + 1)
                }}>
                    <FontAwesomeIcon icon={faCaretRight}/>
                </Button>
            </> : <></>}
            <Button variant="outline-primary" id="button-addon2" disabled={isWaitingResponse}
                    onClick={sendRequest}>
                <FontAwesomeIcon icon={isWaitingResponse ? faCircleNotch : faPaperPlane}
                                 className={isWaitingResponse ? "fa-spin" : ""}/>
            </Button>
        </InputGroup>
        <FloatingLabel className={"labelRequest"} label="body"
                       hidden={!(["POST", "PATCH", "PUT"].indexOf(requestMethod) >= 0)}>
            <Form.Control as="textarea" className="textAreaRequestBody" ref={requestBody}
                          onKeyDown={(e) => {
                              if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) sendRequest();
                          }}/>
        </FloatingLabel>
        <div className={"labelResponse " + responseClass}>
            <label>{requestResponseStatus}</label>
        </div>

        <ReactJsonView
            src={requestResponseContent ? requestResponseContent : {}}
            className={"textAreaResponse"}
            theme={"tomorrow"}
            name={false}
            displayObjectSize={false}
            displayDataTypes={false}
        />
    </Accordion.Body>

}


export default CustomRequest;
